<template>
  <component
    :is="'h' + level"
    :class="classes"
  >
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    level: {
      type: Number,
      default: 1
    }
  },
  computed: {
    classes () {
      console.log(this)
      switch (this.level) {
        default:
        case 1:
          return 'text-white text-3xl md:text-4xl uppercase tracking-wide leading-8 mb-2 md:mb-3'
        case 2:
          return 'text-kwred text-4xl md:text-5xl font-bold mb-6 md:mb-12'
        case 3:
          return 'text-kwred text-4xl md:text-5xl font-thin mb-6 md:mb-12'
        case 4:
          return 'text-kwred text-3xl md:text-4xl font-bold mb-6 md:mb-12'
        case 5:
          return 'text-kwred text-2xl font-bold uppercase tracking-wider mb-8'
        case 6:
          return 'text-kwred text-xl font-bold mb-1'
      }
    }
  }
}
</script>
